import React from 'react';
import {connect} from 'react-redux';

export default function(ComposedComponent) {
  class AuthRoutes extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          basePath : window.location.protocol + '//' + window.location.host + '/',
          redirect: false
        }
        
      }
    
    getHtml = () => { 
      // Allow verify-profile page even if session might be temporarily lost during callback
      const currentPath = window.location.pathname;
      // Check for verify-profile with or without language prefix
      const isVerifyProfile = currentPath === '/verify-profile' || 
                              currentPath.includes('/verify-profile') ||
                              currentPath.endsWith('verify-profile');
      
      // For verify-profile, always allow access (don't check Islogin)
      if (isVerifyProfile) {
        // CRITICAL: If token exists but Islogin is not set, set it to prevent redirects
        // This prevents the redirect loop to home page
        if (localStorage.getItem('token')) {
          localStorage.setItem('Islogin', 'true');
          // Also preserve login_type if it exists
          const loginType = localStorage.getItem('login_type');
          if (!loginType && this.props.actionReducer?.Loginuser?.name) {
            localStorage.setItem('login_type', this.props.actionReducer.Loginuser.name);
          }
        }
        return <ComposedComponent {...this.props} />
      }
      
      // For other pages, check Islogin
      if(localStorage.getItem('Islogin') !== 'true'){
        // Don't redirect if we have a token (session might be temporarily lost)
        if (!localStorage.getItem('token')) {
          window.location.href = "/"
          return null
        } else {
          // We have a token, set Islogin to prevent redirect loop
          localStorage.setItem('Islogin', 'true');
          return <ComposedComponent {...this.props} />
        }
      } else {
        return <ComposedComponent {...this.props} />
      }
    }

    render() {
      return(this.getHtml())
    }
  }

  function mapStateToProps(store) {
    return store
  }

  return connect(mapStateToProps)(AuthRoutes);
}
  
  

